import React from "react";
import { Link } from "react-router-dom";
import { blogPosts, formatPostDate } from "../data/blogPosts";
import "./BlogPage.css";

export default function BlogPage() {
  const sortedPosts = [...blogPosts].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );
  const [featuredPost, ...morePosts] = sortedPosts;

  return (
    <main className="blog-page">
      <div className="blog-inner">
        <header className="blog-header">
          <h1 className="blog-title">PaceNotes</h1>
          <p className="blog-intro">
            Real training advice for real runners. No fluff, no gatekeeping.
          </p>
        </header>

        {featuredPost && (
          <article className="blog-featured">
            <time className="blog-featured-date" dateTime={featuredPost.date}>
              {formatPostDate(featuredPost.date)}
            </time>
            <h2 className="blog-featured-title">
              <Link to={`/blog/${featuredPost.slug}`}>
                {featuredPost.title}
              </Link>
            </h2>
            <p className="blog-featured-excerpt">{featuredPost.excerpt}</p>
            <Link
              to={`/blog/${featuredPost.slug}`}
              className="blog-featured-cta"
            >
              Read More
            </Link>
          </article>
        )}

        {morePosts.length > 0 && (
          <ul className="blog-grid" aria-label="More PaceNotes posts">
            {morePosts.map((post) => (
              <li key={post.slug}>
                <article className="blog-card">
                  <time className="blog-card-date" dateTime={post.date}>
                    {formatPostDate(post.date)}
                  </time>
                  <h3 className="blog-card-title">
                    <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                  </h3>
                  <p className="blog-card-excerpt">{post.excerpt}</p>
                  <Link to={`/blog/${post.slug}`} className="blog-read-more">
                    Read More →
                  </Link>
                </article>
              </li>
            ))}
          </ul>
        )}
      </div>
    </main>
  );
}
